const ICONS_BASE =
  process.env.NODE_ENV === 'development'
    ? '/assets/images/icons'
    : '/local/templates/dist/assets/images/icons';

export const FILE_UPLOAD_ALLOWED_EXTENSIONS = [
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
] as const;

export const FILE_UPLOAD_MAX_SIZE_BYTES = 100 * 1024 * 1024;

export function getFileExtension(fileName: string): string {
  const parts = fileName.split('.');
  if (parts.length < 2) return '';
  return (parts.pop() ?? '').toLowerCase();
}

export function isAllowedUploadExtension(extension: string): boolean {
  return FILE_UPLOAD_ALLOWED_EXTENSIONS.includes(
    extension as (typeof FILE_UPLOAD_ALLOWED_EXTENSIONS)[number],
  );
}

export function formatFileSize(bytes: number): string {
  if (bytes >= 1048576) {
    return `${(bytes / 1048576).toFixed(1).replace('.0', '')} Мб`;
  }
  if (bytes >= 1024) {
    return `${Math.round(bytes / 1024)} Кб`;
  }
  return `${bytes} б`;
}

export function getDeleteFileIconPath(): string {
  return `${ICONS_BASE}/share-icons/delete-icon.svg`;
}

export function getDocFormatIconPath(fileName: string): string {
  const key = getFileExtension(fileName).toUpperCase();

  switch (key) {
    case 'PDF':
      return `${ICONS_BASE}/doc/doc_pdf.svg`;
    case 'DOC':
      return `${ICONS_BASE}/doc/doc_doc.svg`;
    case 'DOCX':
      return `${ICONS_BASE}/doc/doc_docx.svg`;
    case 'XLS':
      return `${ICONS_BASE}/doc/doc_xls.svg`;
    case 'XLSX':
      return `${ICONS_BASE}/doc/doc_xlsx.svg`;
    case 'PPT':
      return `${ICONS_BASE}/doc/doc_ppt.svg`;
    case 'PPTX':
      return `${ICONS_BASE}/doc/doc_pptx.svg`;
    default:
      return `${ICONS_BASE}/doc/doc_none.svg`;
  }
}

export function getFileFormatLabel(fileName: string): string {
  const ext = getFileExtension(fileName);
  return ext ? ext.toUpperCase() : 'FILE';
}
